module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "placeholder": "Votre réponse ...",
      "multi-line": ""
    },
    model: {
      value: (_vm.answer),
      callback: function($$v) {
        _vm.answer = $$v
      },
      expression: "answer"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221f230c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/additional/Verbatim.vue
// module id = 317
// module chunks = 1